export default __webpack_public_path__ + "static/media/horasW.f8a495ec.svg";